import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Student } from '../modal/student';

export const getAllStudentAPI = async () => {
  const response = await baseAPI.get<Array<Student>>(`/students/studio/all`);
  return response.data;
};

export const useGetAllStudents = () => {
  return useQuery({
    queryKey: [KEYS.STUDENTS],
    queryFn: () => getAllStudentAPI(),
  });
};
